module.exports = __webpack_public_path__ + "static/media/menu-profile.bbbbc642.svg";